import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/wifi/enterprise/e7.png";
import type { Product } from "../../types";
import { wifiE7 } from "../product-list-groups/wifi-e7";
import {
  antennaType,
  connectedDevices,
  dedicatedSpectral,
  extendedRangeMode6Ghz,
  fipsCompliance,
  powerMethodPoe,
  radio6Ghz,
  redundantRj45Port,
  rfFilteringTechnology,
  uplink,
  weatherproofing,
  wifiCoverage,
  wifiMounting,
  wifiTechnology,
} from "../properties";

export const e7: Product = {
  id: "e7",
  productTitle: "E7",
  techspecsPath: [SiteId.TechSpecs, `/unifi/${UniFiCategoryId.WiFi}/e7`],
  storePathParts: { productSlug: "e7", category: "wifi-enterprise" },
  sku: "E7",
  description: "e7.description",
  isNew: true,
  image: { src: image, width: 200, height: 160 },
  productListGroup: wifiE7,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '250 x 250 x 43.5 mm\n(9.8 x 9.8 x 1.7")',
      },
    },
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "e7.wifiTechnology",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: extendedRangeMode6Ghz.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: dedicatedSpectral.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: rfFilteringTechnology.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: antennaType.id,
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: wifiCoverage.id,
      value: {
        type: "translation",
        value: "e7.wifiCoverage",
      },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "1,000+" },
    },
    {
      propertyId: weatherproofing.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: powerMethodPoe.id,
      value: { type: "string", value: "PoE++" },
    },
    {
      propertyId: uplink.id,
      value: { type: "translation", value: "e7.uplink" },
    },
    {
      propertyId: redundantRj45Port.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: wifiMounting.id,
      value: {
        type: "translation",
        value: "e7.mounting.1",
        asterisk: 3,
      },
    },
    {
      propertyId: fipsCompliance.id,
      value: { type: "boolean", value: true, asterisk: 3 },
    },
  ],
  notes: ["e7.notes.2"],
};
